import { _converse,api } from '@converse/headless';
import { CustomElement } from './element.js';
import { html } from 'lit';
import 'shared/components/logo.js';

export class ConverseBrandLogo extends CustomElement {

    static get properties() {
        return {
            hide_byline: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.hide_byline = false;
    }

    render() {
        const is_fullscreen = api.settings.get('view_mode') === 'fullscreen';
        return html`<a class="brand-heading"><span class="brand-name-wrapper ${is_fullscreen ? 'brand-name-wrapper--fullscreen' : ''}"><img src="https://xmpp.uni-konstanz.de/files/konverse/unikn-logo.svg" alt="Logo of University of Konstanz"></span></a><div class="col-12 text-center"><p class="brand-subtitle mb-2 subdued">konverse: ${_converse.VERSION_NAME}</p></div>`;
    }
}

api.elements.define('converse-brand-logo', ConverseBrandLogo);
